export const DEVICE_WIDTH_MOBILE = 375;
export const DEVICE_WIDTH_TABLET = 768;
export const DEVICE_WIDTH_DESKTOP = 1024;

export const device = {
  mobile: `(min-width: ${DEVICE_WIDTH_MOBILE}px)`,
  tablet: `(min-width: ${DEVICE_WIDTH_TABLET}px)`,
  desktop: `(min-width: ${DEVICE_WIDTH_DESKTOP}px)`,
};
